import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'i2g-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() zeroPadding = false;

  @HostBinding('class.zero-padding')
  get zeroPaddingComponent(): boolean {
    return this.zeroPadding;
  }
}
